import { render, staticRenderFns } from "./WhatsappContactListV2.vue?vue&type=template&id=2b38117b&scoped=true"
import script from "./WhatsappContactListV2.vue?vue&type=script&lang=js"
export * from "./WhatsappContactListV2.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./WhatsappContactListV2.vue?vue&type=style&index=1&id=2b38117b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b38117b",
  null
  
)

export default component.exports